import React from "react";
import {useBehaviour} from "./useBehaviour";
import {View} from "./view";
import {repositories} from "../../externals";

export const SchemesList = () => {
  return (
    <View {...useBehaviour({ sources: repositories })} />
  );
};